import {hasFeatureFlag} from '../FeatureUtil';
import {hasModule} from '../ModuleUtil';
import {MODULE_TYPES} from '../../../../constants';
import {Company} from '@/containers/settings/types';

type SageTimeRegsSyncType = Pick<Company, 'sageIntacctConnectionEnabled' | 'sageIntacctTimeRegsFromForecast'>;

export default class SageUtil {
	static isSageAccount = (): boolean => {
		return hasFeatureFlag('use_sage_service_for_time_regs') && hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED);
	};

	static syncTimeRegsFromForecast = (company: SageTimeRegsSyncType): boolean => {
		return company.sageIntacctConnectionEnabled === true && company.sageIntacctTimeRegsFromForecast === true;
	};

	static syncTimeRegsFromIntacct = (company: SageTimeRegsSyncType): boolean => {
		return company.sageIntacctConnectionEnabled === true && company.sageIntacctTimeRegsFromForecast === false;
	};

	static isSageIntacctEnabled = (company: {sageIntacctConnectionEnabled?: boolean | null}): boolean => {
		return company.sageIntacctConnectionEnabled === true;
	};

	static isSagePSA = (): boolean => {
		return hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED);
	};
}
